import { headerBarList } from '~/constants/headerBarList';
import { Link } from 'react-router-dom';
import styles from './headerBar.module.scss';
import { AuthenticationContext } from '~/components/Authentication/AuthenticationProvider';
import { useContext } from 'react';
import { checkIfFoodAdmin, checkIfUserSuperAdmin } from '~/utils/getUserRole';

const HeaderBar = (): JSX.Element => {
  const links = headerBarList();
  const { user } = useContext(AuthenticationContext);
  const isSuperAdminAccess = checkIfUserSuperAdmin(user?.data.role_name);
  const isFoodAdminAccess = checkIfFoodAdmin(user?.data.role_name);
  const allowedAssetRoutes = user?.data.admin_sections;
  const allowedRoutes = user?.data.sections;

  const updatedAllowedRoutes = allowedRoutes?.map(item => {
    if (item.type === 'storage') {
      return {
        ...item,
        type: 'documents',
      };
    } else if (item.type === 'knowledge_base') {
      return {
        ...item,
        type: 'knowledge-base',
      };
    } else {
      return item;
    }
  });

  const updatedAllowedAssetRoutes = allowedAssetRoutes?.map(item => {
    if (item.type === 'storage') {
      return {
        ...item,
        type: 'documents',
      };
    } else if (item.type === 'knowledge_base') {
      return {
        ...item,
        type: 'knowledge-base',
      };
    } else {
      return item;
    }
  });

  const filteredLinks = links.filter(link => {
    if (isSuperAdminAccess) {
      return link.path !== '/transactions';
    }

    if (isFoodAdminAccess) {
      return link.path === '/transactions';
    }

    const linkType = link.path.replace('/', '');
    return (
      updatedAllowedRoutes?.some(section => section.type === linkType) &&
      updatedAllowedAssetRoutes?.some(section => section.type === linkType)
    );
  });

  return (
    <nav className={styles.navHeader}>
      <ul className={styles.navHeader__list}>
        {filteredLinks?.map(({ id, path, text, Icon }) => {
          return (
            <li key={id} className={styles.navHeader__item}>
              <Link to={path} className={styles.navHeader__link}>
                <Icon />
                <span className={styles.navHeader__itemText}>{text}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default HeaderBar;
